import { faCirclePlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./ScopeOfTheLaboratory_Form.css";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useState } from "react";

function ScopeOfTheLaboratory_Form() {
   const onSubmit = async (data) => {
      setSuccess(true);
  
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
    };
  
    const [success, setSuccess] = useState(false);
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="row">
            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Discipline/ Group</Form.Label>
                <Form.Control value="Scope Abc" disabled />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Material Or Products Tested</Form.Label>
                <Select options={options} value="Scope Abc" />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>
                  Component, Parameter Or Characteristic Tested/ Specific Test
                  Performed / Tests Or Type Of Tests Performed
                </Form.Label>
                <Select options={options} value="Scope Abc" />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group file_field">
                <Form.Label>
                  Test Method Specification against which tests are performed
                  and/or the techniques/equipment used
                </Form.Label>

                <Select options={options} value="Scope Abc" />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach Scope Document</Form.Label>
                <div className="absolute_fields">
                  <Form.Control value="Upload File" disabled />
                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                  </div>
                </div>
                <div className="image_holder">
                  <img
                    className="img_preview"
                    src="/assets/images/other/dummy-image.png"
                  />
                </div>
              </Form.Group>
            </div>

            <div className="col-12">
              <div className="add_another_holder">
                <div>
                  <span><FontAwesomeIcon icon={faCirclePlus} /> Add Another Document</span>
                </div>
              </div>
            </div>
          </div>

           <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default ScopeOfTheLaboratory_Form;
